import { objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isSdkDebuggerRecordingIdStopResult = objectOf({
  documents_updated: number,
  result: objectOf({
    id: string,
  }),
});
